export const NotFound = () => {
    return (
        <>
            <h2>Not Found</h2>
        </>
    )
}